import React from 'react';
import '../style/About.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// react redux
import { connect } from 'react-redux';

// import Gallery from 'react-photo-gallery';
import PhotoGallery from '../components/thirdParty/PhotoGallery';

function About({ lang }) {
  const tibetanCalligraphy = [
    {
      // no 4

      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy4.jpg?alt=media&token=d151c2e8-2829-4383-bc2c-78db79ee03c1',
      width: 5,
      height: 3,
    },
    {
      // no 13
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy1.jpg?alt=media&token=614d8397-51fb-4834-9087-04217a9943e9',
      width: 2,
      height: 3,
    },
    {
      // no 11
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy11.jpg?alt=media&token=cdf80e2c-8561-4a46-9693-670ae5bcaba6',
      width: 2,
      height: 3,
    },
    {
      // no 13
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy13.jpg?alt=media&token=66685562-ca7a-4215-b929-e3bfd352fb29',
      width: 2,
      height: 3,
    },
    {
      // no 12
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy12.jpg?alt=media&token=b3694f80-e3df-4064-b083-deef0e599d17',
      width: 5,
      height: 3,
    },
    {
      //no 10 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy10.jpg?alt=media&token=9021d641-97ac-4df8-9536-26a9271ee5c5',
      width: 5,
      height: 3,
    },

    {
      //no 5 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy5.jpg?alt=media&token=866ac4f7-d73f-44db-8db9-05cd672fd840',
      width: 5,
      height: 3,
    },
    {
      //no 3 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy3.jpg?alt=media&token=b4a491d0-faa0-4e45-bd78-dbb5906cf61a',
      width: 5,
      height: 3,
    },
    {
      //no 2 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy2.jpg?alt=media&token=3126d02e-14ed-4263-8e9c-b537aa344ad8',
      width: 2,
      height: 5,
    },
    {
      //no 6 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy6.jpg?alt=media&token=ed118d18-336e-498f-9005-596a47b05b88',
      width: 5,
      height: 3,
    },
    {
      //no 7 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy7.jpg?alt=media&token=d3f8b2c9-9cda-40e2-8943-f88a8e7c23eb',
      width: 5,
      height: 3,
    },
    {
      //no 8 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy8.jpg?alt=media&token=8c13e6ba-96b0-4a79-b867-5f8dd96df4cf',
      width: 3,
      height: 3,
    },
    {
      //no 9 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fcalligraphy9.jpg?alt=media&token=29186fea-3840-47de-894e-d4e63f9860f5',
      width: 5,
      height: 4,
    },

  ];

  const drawing = [
    {
      // no 10
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing10.jpg?alt=media&token=62c43e4b-eefe-44fe-a6b2-7ac7571a9fa4',
      width: 5,
      height: 3
    },
    {
      // no 11
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing11.jpg?alt=media&token=04835b12-0afa-431c-b23b-fbaae1ecbbd3',
      width: 4,
      height: 4
    },
    {
      // no 12
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing12.jpg?alt=media&token=d5f6464b-b8ad-441e-8c16-b7825ac9b125',
      width: 3,
      height: 5
    },
    {
      // no 13
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing13.jpg?alt=media&token=b8532e19-ceb4-4a70-998b-54d5077aea29',
      width: 3,
      height: 3
    },
    {
      // no 14
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing14.jpg?alt=media&token=55863f6f-7f4c-46cc-ad54-bc91ab99ca1d',
      width: 3,
      height: 3
    },
    {
      // no 2
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing2.jpg?alt=media&token=b6e7a79c-9314-4ed7-8c70-ce852468ca2a',
      width: 3,
      height: 5
    },
    {
      // no 8
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing8.jpg?alt=media&token=7cc0610f-219d-4dbb-93e2-1849207141d5',
      width: 3,
      height: 5
    },
    {
      // no 3
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing3.jpg?alt=media&token=b872980d-be52-4614-8b9c-617e4ba9b7ba',
      width: 3,
      height: 5
    },

    {
      // no 5
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing5.jpg?alt=media&token=2d80b44c-52c2-45e5-b12e-27cc93ef494b',
      width: 5,
      height: 3
    },
    {
      // no 6
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing6.jpg?alt=media&token=44d03825-7050-42df-b82c-34caa5bf0923',
      width: 5,
      height: 3
    },
    {
      // no 7
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fdrawing7.jpg?alt=media&token=b2657002-9fbb-4590-8341-e240b6cd2bb8',
      width: 5,
      height: 3
    },
  ]

  const chineseCalligraphy = [
    {
      // no 8
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy8.jpg?alt=media&token=27507da8-3ebe-4339-bd02-c58b81714b67        ',
      width: 3,
      height: 5,
    },
    {
      // no 9
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy9.jpg?alt=media&token=16e31105-cb0e-4ecd-8b35-ab4544c2c586        ',
      width: 3,
      height: 5,
    },
    {
      // no 10
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy10.jpg?alt=media&token=c1f496b1-1a03-4dd5-b2e1-2a70893b290e',
      width: 3,
      height: 5,
    },
    {
      // no 11
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy11.jpg?alt=media&token=e6ca94db-37c5-4d7a-bbd3-5db51f09b490',
      width: 3,
      height: 5,
    },
    {
      // no 12
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy12.jpg?alt=media&token=836603f8-55a0-497b-bf51-86b302f6937e        ',
      width: 3,
      height: 5,
    },
    {
      // no 13
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy13.jpg?alt=media&token=f6282db7-f3fa-4954-9bfb-227df03ecd3b',
      width: 3,
      height: 5,
    },
    {
      // no 14
      src: ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy14.jpg?alt=media&token=f41f0644-48b2-4998-a7d6-45c03173f130        ',
      width: 3,
      height: 5,
    },
    {
      // no 1
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy1.jpg?alt=media&token=152b54ea-cd6f-47c5-a7fc-53a474ac20a8        ',
      width: 3,
      height: 5,
    },
    {
      // no 2
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy2.jpg?alt=media&token=2a91c7bb-2497-419f-be1f-d6c0d95c2b90        ',
      width: 3,
      height: 5,
    },
    {
      // no 3
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy3.jpg?alt=media&token=67caaa4e-32bd-44cb-b557-236f61687aae        ',
      width: 3,
      height: 5,
    },
    {
      // no 4
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy4.jpg?alt=media&token=a645526f-a2d3-49e2-8e22-f88a73b21d17',
      width: 3,
      height: 5,
    },
    {
      // no 5
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy5.jpg?alt=media&token=3edf90a1-f6a9-41ac-8852-82ef04855059',
      width: 5,
      height: 3,
    },
    {
      // no 6
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy6.jpg?alt=media&token=c5caee0e-08bc-42f5-9a94-af2a74a84356',
      width: 3,
      height: 5,
    },
    {
      // no 7
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FchineseCalligraphy7.jpg?alt=media&token=90d5f260-268d-4087-b391-29b9e800002e',
      width: 3,
      height: 5,
    },


  ]
  return (
    <>
      <Header />
      <Container className='about'>
        <div className='aboutBody p-5'>
          <Row>
            <Col>
              {lang === 'CH' ? (
                <h3 className='text-left text-secondary chinese'>
                  書法作品
                </h3>
              ) : lang === 'TIB' ? (
                <h3 className='text-left text-secondary tibetan_Dutsa'>
                  བོད་ཡིག
                </h3>
              ) : (
                    <h3 className='text-left text-secondary'>
                      English
                    </h3>
                  )}
            </Col>
          </Row>
          <Tab.Container id="left-tabs" defaultActiveKey="first">
            <Row>
              <Col sm={3}>
                <Nav variant="pills" className="flex-column">
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey="first">藏文書法</Nav.Link>
                  </Nav.Item>
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey="third">中文書法</Nav.Link>
                  </Nav.Item>
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey="second">
                      畫畫
          </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey="forth">
                      詩詞
          </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>


              <Col sm={9}>
                <Tab.Content className='tabContent'>
                  <Tab.Pane eventKey="first" className='tabPane'>

                    <Row className='aboutContent d-flex align-items-center justify-content-center'>

                      <Col className='align-items-center  justify-content-center'>
                        <PhotoGallery images={tibetanCalligraphy} />
                      </Col>
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second" className='tabPane'>

                    {/*Drawing   */}
                    <Row className='aboutContent d-flex align-items-center justify-content-center'>
                      <Col className='align-items-center  justify-content-center'>
                        <PhotoGallery images={drawing} />
                      </Col>
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="third" className='tabPane'>
                    {/*Chinese Calligraphy   */}
                    <Row className='aboutContent d-flex align-items-center justify-content-center'>
                      <Col className='align-items-center  justify-content-center'>
                        <PhotoGallery images={chineseCalligraphy} />
                      </Col>
                    </Row>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>

        </div>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

export default connect(mapStateToProps)(About);
